export type PropertyNode =
	| {
			readonly value?: string | null;
			readonly version?: { readonly number?: number | null } | null;
	  }
	| null
	| undefined;

/** A value stored in a content property, with the property version (0 when not stored). */
export type StoredValue<V> = {
	value: V | undefined;
	version: number;
	isStored: boolean;
};

export const NOT_STORED: StoredValue<never> = { value: undefined, version: 0, isStored: false };

const decode = (value: string | null | undefined): unknown => {
	if (!value) {
		return undefined;
	}
	try {
		return JSON.parse(value);
	} catch {
		return undefined;
	}
};

/** Reads a content property. `parse` gets the JSON-decoded value and returns undefined for one it doesn't recognise. */
export const readStoredValue = <V>(
	nodes: readonly PropertyNode[] | null | undefined,
	parse: (decoded: unknown) => V | undefined,
): StoredValue<V> => {
	const node = nodes?.[0];
	return {
		value: parse(decode(node?.value)),
		version: node?.version?.number ?? 0,
		isStored: Boolean(node),
	};
};
